import React from "react";
import ChatIcon from "../../../icons/ChatIcon";

import styles from "../Button/Button.module.scss";

interface ChatSupportProps {
  style?: any;
}

const ChatSupport: React.FC<ChatSupportProps> = ({ style }) => {
  return (
    <div
      className={styles.supportBtn}
      style={{ ...style }}
      onClick={() => {
        const chatUrl = `https://v2.zopim.com/widget/livechat.html?key=2AekYJAlcSZCOOwpwwxkRyIkGeHIDfty&api_calls=[["concierge.setName",["Suralink Support"]],["concierge.setTitle",["Suralink Support"]],["theme.reload",[]],["theme.reload",[]]]&hostname=${window.location.href}&lang=en`;
        window.open(
          chatUrl,
          "_blank",
          "location=yes,height=570,width=440,scrollbar=yes,status=yes"
        );
      }}
    >
      Live chat support
      <span style={{ position: "relative", left: "8px", top: "1px" }}>
        <ChatIcon fillColor="#2a5a8c" />
      </span>
    </div>
  );
};

export default ChatSupport;
